<template>
  <v-stepper-content v-bind="$attrs">
    <v-card>
      <v-card-title>
        Выберите объект
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          color="green"
          :value="value"
          @change="e => $emit('input', e)"
          :items="filtered_objects"
        >

        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="$emit('back')"
          text
        >
          <v-icon small>mdi-arrow-left</v-icon>
          Назад
        </v-btn>

        <v-btn
          @click="$emit('next')"
          color="green"
          text
          :disabled="value == 0"
        >
          <v-icon small>mdi-page-next-outline</v-icon>
          Далее
        </v-btn>
        
        
      </v-card-actions>
    </v-card>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props:['value', 'dealer_id'],
  computed:{
    ...mapGetters(['objects']),
    filtered_objects(){
      return this.objects.filter( el => (!el.isDeleted) && (el.dealerId == this.dealer_id)).map( el => {
        return {
          text: `(${el.id}) ${el.objectName}`,
          value: el.id
        }
      })
    }
  }
}
</script>